import { CONSULTANT_ROLE_ID } from '../shared/constants';

export const TOTAL_STEPS = 2;

export const PAGE_TITLE = 'Créer un compte consultant';

export const getCreateAccountTitle = (roleId?: number | '', roleName?: string) => {
  if (Number(roleId) === CONSULTANT_ROLE_ID || !roleName) {
    return PAGE_TITLE;
  }
  return `Créer un compte ${roleName}`;
};

export const EMAIL_ALREADY_USED_MESSAGE =
  'Attention, cette adresse mail correspond déjà à un utilisateur.';

export const CREATE_SUCCESS = 'Le compte a été créé avec succès';
